/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Recorder_Recording_In_ProgressInputs */

const en_audio_recorder_recording_in_progress = /** @type {(inputs: Audio_Recorder_Recording_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RECORDING IN PROGRESS`)
};

const fr_audio_recorder_recording_in_progress = /** @type {(inputs: Audio_Recorder_Recording_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ENREGISTREMENT EN COURS`)
};

const de_audio_recorder_recording_in_progress = /** @type {(inputs: Audio_Recorder_Recording_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AUFNAHME IN BEARBEITUNG`)
};

const it_audio_recorder_recording_in_progress = /** @type {(inputs: Audio_Recorder_Recording_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`REGISTRAZIONE IN CORSO`)
};

const ru_audio_recorder_recording_in_progress = /** @type {(inputs: Audio_Recorder_Recording_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ЗАПИСЬ В ПРОЦЕССЕ`)
};

const es_audio_recorder_recording_in_progress = /** @type {(inputs: Audio_Recorder_Recording_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GRABACIÓN EN CURSO`)
};

const zh_cn2_audio_recorder_recording_in_progress = /** @type {(inputs: Audio_Recorder_Recording_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`录制进行中`)
};

const ja_audio_recorder_recording_in_progress = /** @type {(inputs: Audio_Recorder_Recording_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`録音中`)
};

const hi_audio_recorder_recording_in_progress = /** @type {(inputs: Audio_Recorder_Recording_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रिकॉर्डिंग जारी है`)
};

const pt_pt2_audio_recorder_recording_in_progress = /** @type {(inputs: Audio_Recorder_Recording_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GRAVAÇÃO EM ANDAMENTO`)
};

/**
* | output |
* | --- |
* | "RECORDING IN PROGRESS" |
*
* @param {Audio_Recorder_Recording_In_ProgressInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_recording_in_progress = /** @type {((inputs?: Audio_Recorder_Recording_In_ProgressInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_Recording_In_ProgressInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_recorder_recording_in_progress(inputs)
	if (locale === "de") return de_audio_recorder_recording_in_progress(inputs)
	if (locale === "it") return it_audio_recorder_recording_in_progress(inputs)
	if (locale === "ru") return ru_audio_recorder_recording_in_progress(inputs)
	if (locale === "es") return es_audio_recorder_recording_in_progress(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_recorder_recording_in_progress(inputs)
	if (locale === "ja") return ja_audio_recorder_recording_in_progress(inputs)
	if (locale === "hi") return hi_audio_recorder_recording_in_progress(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_recorder_recording_in_progress(inputs)
	return en_audio_recorder_recording_in_progress(inputs)
});